// packages/content/src/tuning/mail.ts (M1-T01, §7.2) — rev 4 adds the letter-from-home numbers, rev 8 homeGiftFruitShare
import type { TuningBank } from '../schema/tuning';
export default { maxChars: 500, keep: 100, homeGiftChance: 0.5, homeGiftFruitShare: 0.5, homeGiftMaxBuy: 3000, homeRepeatDays: 3 } as const satisfies TuningBank;
